import React from 'react';
import {Container, Grid, TextField} from "@mui/material";
import ChatMessageList from "./ChatMessageList";
import {Chat} from "./Models";

const ChatWindow = () => {
    const [chat, setChat] = React.useState<Chat | undefined>();
    
    const onSelect = (chat: Chat) => {
        console.log("onSelect", chat.name);
        setChat(chat);
    }
    
    return (
        <Grid container spacing={2}>
            <Container>
                <ChatMessageList chat={chat}/>
            </Container>
        </Grid>
    );
}

export default ChatWindow;